<template>
  <div style="margin: 0; position: relative">
    <div
      v-if="isLoading"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.6);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      "
    >
      <div style="margin-bottom: 1rem; font-size: 1.2rem">Loading...</div>
      <div class="loader-circle"></div>
    </div>

    <div style="margin: 0">
      <vs-card style="padding: 0 !important; margin: 0 !important">
        <vs-row style="background: linear-gradient(118deg, rgba(var(--vs-primary),1), rgba(var(--vs-primary),0.7));
              padding: 10px 12px !important;
              margin: 0 important;
              display: flex;
              align-items: center; ">
              <vs-col class="w-1/2">
            <h4 style="margin-left: 14%; color: white; padding: 0">Billing</h4>
          </vs-col>
          <vs-col class="w-1/2">
            <div style="margin-left: 90%; cursor: pointer">
              <feather-icon
                icon="XIcon"
                style="color: white"
                class="custom-class"
                title="close"
                @click="exit"
              ></feather-icon>
            </div>
          </vs-col>
        </vs-row>

        <vs-divider style="margin-top: 0"></vs-divider>

        <div style="padding-left: 4%; padding-right: 4%">
          <vs-row>
            <vs-alert
              color="danger"
              icon-pack="feather"
              icon="icon-info"
              v-for="(errors, err) in errorMessage"
              v-bind:key="err"
            >
              <span>{{ errors }}</span>
            </vs-alert>
            <vs-alert
              color="danger"
              icon-pack="feather"
              icon="icon-info"
              v-for="error in errors.all()"
              v-bind:key="error"
            >
              <span>{{ error }}</span>
            </vs-alert>
          </vs-row>
          <vs-row style="margin-left: 2%">
            <!-- Left Column: Bill No. + Patient Details -->
            <vs-col vs-lg="6" vs-sm="12" class="pr-2 pl-4">
              <!-- Bill Number -->
              <vs-row class="mb-3" style="margin-top: 2%">
                <vs-col>
                  <vs-row class="mb-1">
                    <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="topPad">
                      <span class="inputStyles">Bill No.</span>
                    </vs-col>

                    <vs-col vs-lg="3" vs-md="6" vs-sm="12">
                      <vs-input
                        v-model="BillData.billId"
                        readonly
                        class="bill-input"
                      />
                    </vs-col>
                    <vs-col
                      vs-lg="1"
                      vs-md="2"
                      vs-sm="2"
                      class="p-0"
                      style="display: flex; align-items: center"
                    >
                      <div title="search">
                        <SearchIcon
                          style="
                            margin-top: 5px;
                            cursor: pointer;
                            width: 20px;
                            height: 20px;
                          "
                          @click="goTobillDashboard"
                        />
                      </div>
                    </vs-col>
                    <vs-col
                      vs-lg="1"
                      vs-md="2"
                      vs-sm="2"
                      class="p-0"
                      style="
                        display: flex;
                        align-items: center;
                        margin-left: -15px;
                      "
                    >
                      <div v-if="showRefreshIcon" title="Clear">
                        <RefreshCwIcon
                          style="
                            margin-top: 5px;
                            cursor: pointer;
                            width: 18px;
                            height: 18px;
                          "
                          @click="refreshBillPage"
                          title="clear"
                        />
                      </div>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
              <div style="margin-top: 3%">
                <!-- Patient Details component -->
                <patient-details
                  :patientId="patientId"
                  :patientDetails="patientDetails"
                  :showSearchIcon="showSearchIcon"
                  @fetchPatient="onFetchPatient"
                     source-type="bill"
                />
              </div>
            </vs-col>

            <!-- Right Column: Bill Date, Type, Reference, Note -->
            <vs-col vs-lg="6" vs-sm="12" class="pl-2">
              <!-- Added padding -->
              <vs-row class="mb-3" style="margin-top: 2%">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Bill Date</span>
                </vs-col>
                <vs-col vs-lg="4" vs-sm="6">
                  <vs-input
                    :value="formatDate(BillData.billDate)"
                    readonly
                    style="width: 220px"
                  />
                </vs-col>
              </vs-row>
              <div style="margin-top: 4%">
                <vs-row class="mb-1">
                  <vs-col vs-lg="3" class="topPad">
                    <span class="inputStyles">Bill Type *</span>
                  </vs-col>
                  <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                    <select
                      v-model="BillData.billType"
                      class="vs-select--input myselect"
                      style="width: 220px"
                      v-validate="'required'"
                      name="BillType"
                      @change="getBillReference"
                      :disabled="readonlyFlag"
                    >
                      <option
                        v-for="(item, index) in billtypes"
                        v-bind:key="index"
                        :value="item.typeId"
                      >
                        {{ item.typeName }}
                      </option>
                    </select>
                  </vs-col>
                </vs-row>
              </div>
              <vs-row class="mb-1" style="margin-top: 1%">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Reference *</span>
                </vs-col>
                <vs-col vs-lg="4" class="sm:w-1/4 w-full">
                  <select
                    v-model="BillData.refId"
                    class="vs-select--input myselect"
                    style="height: 36px; width: 220px"
                    name="BillReference"
                    :disabled="readonlyFlag"
                    @change="setDoctorFromReference"
                  >
                    <option
                      v-for="(item, index) in reference"
                      v-bind:key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>

              <vs-row class="mb-1" style="margin-top: 1%">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Note</span>
                </vs-col>
                <vs-col vs-lg="4" vs-sm="6">
                  <vs-textarea
                    style="width: 220px; min-height: 80px"
                    v-model="BillData.note"
                    :readonly="readonlyFlag"
                  />
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>

          <vs-row class="mt-3">
            <vs-col vs-lg="11">
              <billing-table
                ref="billing"
                :patientId="patientId"
                :BillData="BillData"
                :billingType="['clinic', 'lab']"
                style="padding-left: 4%; padding-right: 9%; padding-bottom: 10%"
              ></billing-table>
            </vs-col>
            <vs-col vs-lg="1"> </vs-col>
          </vs-row>
        </div>
      </vs-card>
      <vs-row>
        <vs-col vs-lg="10">
          <vs-card class="footer" style="padding: 10px">
            <div
              class="btn-group"
              style="
                display: flex;
                justify-content: flex-end;
                gap: 5px;
                padding-right: 0;
                margin-right: 290px;
                flex-wrap: wrap;
              "
            >
              <vs-button
                style="width: 100px"
                v-bind:disabled="saveFlag"
                color="success"
                @click="Save"
                type="gradient"
                >Save</vs-button
              >
              <vs-button style="width: 100px" @click="print" type="gradient"
                >Print</vs-button
              >
              <vs-button
                style="width: 100px"
                @click="exit"
                color="danger"
                type="gradient"
                >Exit</vs-button
              >
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <print-bill
       ref="printBill"
        v-show="showBill"
        style="display: none"
        :patientId="patientId"
        :billPrintData="BillData"
        :patientDetails="patientDetails"
        :doctorName="selectedDoctor.name"
      ></print-bill>
    </div>
  </div>
</template>

<script>

import { SearchIcon, RefreshCwIcon } from "vue-feather-icons";
import BillingTable from "../components/BillingTable.vue";
import PatientDetails from "../components/PatientDetails.vue";
import PrintBill from "../components/PrintBill.vue";

export default {
  components: {
    BillingTable,
    PatientDetails,
    PrintBill,
    SearchIcon,
    RefreshCwIcon,
  },
  data() {
    return {
      BillData: {
        billItems: [
          {
            slNo: 1,
            billItemId: 0,
            billItem: "",
            qty: "1",
            rate: "",
            amount: "",
            taxId: 0,
            taxAmount: "",
            gstValue: "",
          },
        ],
        paymentModeId: 1,
        paymentMode: "Cash",
        subTotal: "",
        receiptAmount: "",
        balanceAmount: "",
        totalAmount: "",
        discount: "",
        discountType: "V",
        refId: "",
        billType: "0",
        note: "",
        billId: "New",
        billDate: new Date().toISOString().slice(0, 10),
        attachedFlag: "N",
      },
      patientId: "",
        showBill:false,
      billtypes: [
        {
          typeId: "0",
          typeName: "Select",
        },
      ],
      reference: [
        {
          id: "0",
          name: "Select",
        },
      ],
      saveFlag: false,
      printFlag: true,
      readonlyFlag: false,
      patientDetails: {},
      showSearchIcon: true,
      errorMessage: [],
      showRefreshIcon: true,
      isLoading: true,
          selectedDoctor: {
      id: null,
      name: ""
    },
    };
  },
watch: {
  'BillData.refId'(newVal) {
    if (newVal) this.setDoctorFromReference();
  }
},


  async beforeMount() {
    this.isLoading = true;
    try {
      if (this.$store.state.opData) {
        this.patientId = this.$store.state.patientId;
        this.$store.dispatch("updateOpData", "");
        this.$store.dispatch("updatePatientId", "");
        if (this.patientId) {
          await this.getpatientDetails();
        }
      } else if (this.$route.query.patientId) {
        // this.showRefreshIcon = false;
        this.patientId = this.$route.query.patientId;
        await this.getpatientDetails();
      }
      if (this.$route.query.billId) {
        // this.showRefreshIcon = false;
        this.BillData.billId = this.$route.query.billId;
        await this.getBillDetails();
      }
      await this.getBillType();
    } catch (error) {
      console.error("Error during mounted init:", error);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    },
    async getpatientDetails() {
      try {
        var request = {
          companyId: this.$session.get("companyId"),
          regNo: this.patientId,
        };
        const response = await this.$http.post(
          "getpatiententry",
          JSON.stringify(request),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.data) {
          this.patientDetails = response.data.data;
          this.errorMessage = [];
        } else {
          this.patientDetails = {};
          this.$vs.notify({
            title: "Patient Not Found",
            text: `No patient found with ID ${this.patientId}.`,
            color: "warning",
            position: "top-right",
          });
        }
      } catch (error) {
        console.error("Error fetching patient details:", error);
        this.patientDetails = {};
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch patient details. Please try again.",
          color: "danger",
          position: "top-right",
        });
      }
    },

    async getBillDetails() {
      try {
        const request = {
          companyId: this.$session.get("companyId"),
          billId: this.BillData.billId,
        };

        const response = await this.$http.post(
          "getbilldetails",
          JSON.stringify(request),
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        console.log("Bill Details API:", response.data.data);

        if (response.data.data) {
          // Map billItems for multiselect
          this.BillData = {
            ...response.data.data,
            billItems: response.data.data.billItems.map((item) => ({
              ...item,
              billItem: {
                id: item.billItemId,
                name: item.billItem, // convert string into object for multiselect
              },
            })),
          };
            if (response.data.data.doctorId) {
    this.selectedDoctor = {
      id: response.data.data.doctorId,
      name: response.data.data.doctorName,
    };
  }

         // this.getBillReference();

          if (parseFloat(this.BillData.receiptAmount) > 0) {
            this.readonlyFlag =
              this.saveFlag =
              this.$refs.billing.readonlyFlag =
                true;
          } else {
            this.readonlyFlag =
              this.saveFlag =
              this.$refs.billing.readonlyFlag =
                false;
          }
        } else {
          this.BillData = {
            billItems: [],
            paymentModeId: "1",
            discountType: "V",
          };
          this.readonlyFlag =
            this.saveFlag =
            this.$refs.billing.readonlyFlag =
              false;
        }

        setTimeout(() => {
          this.$refs.billing.showTotal();
        }, 1000);
      } catch (error) {
        console.error("Error in getBillDetails:", error);
        this.readonlyFlag =
          this.saveFlag =
          this.$refs.billing.readonlyFlag =
            true;
      }
    },

    onFetchPatient(patientId) {
      console.log(" Received fetchPatient event with:", patientId);
      this.patientId = patientId; // update parent patientId
      this.getpatientDetails(); // fetch patient details
    },
    async getBillType() {
      try {
        const request = {
          companyId: this.$session.get("companyId"),
        };

        const response = await this.$http.post(
          "getbilltypes",
          JSON.stringify(request),
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        this.billtypes = [];

        response.data.data.forEach((element) => {
          this.billtypes.push(element);
        });
        if (this.BillData.billId === "New") {
          const generalType = this.billtypes.find(
            (item) => item.typeName === "GENERAL"
          );
          if (generalType) {
            this.BillData.billType = generalType.typeId;
            this.getBillReference();
          }
        } 
      } catch (error) {
        console.error("Error in getBillType:", error);
      }
    },

    refreshBillPage() {
      // Reset bill data to default
      this.BillData = {
        billItems: [
          {
            slNo: 1,
            billItemId: 0,
            billItem: "",
            qty: "1",
            rate: "",
            amount: "",
            taxId: 0,
            taxAmount: "",
            gstValue: "",
          },
        ],
        paymentModeId: 1,
        paymentMode: "Cash",
        subTotal: "",
        receiptAmount: "",
        balanceAmount: "",
        totalAmount: "",
        discount: "",
        discountType: "V",
        refId: "",
        billType: "0",
        note: "",
        billId: "New",
        billDate: new Date().toISOString().slice(0, 10),
        attachedFlag: "N",
      };
      this.$router.replace({ query: {} });
      this.billtypes = [];
      this.reference = [];

      // Reload bill types (like on load)
      this.getBillType();
      // Clear patient info
      this.patientId = "";
      this.patientDetails = {};

      // Reset flags
      this.saveFlag = false;
      this.printFlag = true;
      this.readonlyFlag = false;
      this.errorMessage = [];

      if (this.$validator && typeof this.$validator.reset === "function") {
        this.$validator.reset();
      }
    },

    getBillReference() {
      var request = {
        companyId: this.$session.get("companyId"),
        patientId: this.patientId,
        billType: this.BillData.billType,
      };
      this.$http
        .post("v2/getbillreference", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.reference = response.data.data;
          if (!this.BillData.refId || this.BillData.refId === "") {
            if (this.BillData.billType === "3" && this.reference.length === 1) {
              // GENERAL type, auto-select
              this.BillData.refId = this.reference[0].id;
            } else {
              // For new OP/IP bills, let user choose manually
              this.BillData.refId = "";
            }
          }

          // Safety check — ensure current refId exists in list
          const found = this.reference.find(
            (r) => r.id === this.BillData.refId
          );
          if (!found) {
            this.BillData.refId = "";
          }
           if (this.BillData.refId) {
      this.setDoctorFromReference();
    }
   

        });
    },
    
   setDoctorFromReference() {
   console.log("refId:", this.BillData.refId);
console.log("typeof refId:", typeof this.BillData.refId);
console.log("typeof reference id:", typeof this.reference[0].id);
  const selected = this.reference.find(r => r.id == this.BillData.refId);

  if (selected) {
    this.selectedDoctor.id = selected.doctorId || null;
    this.selectedDoctor.name = selected.doctorName || "";
  } else {
    this.selectedDoctor.id = null;
    this.selectedDoctor.name = "";
  }

  console.log("Selected Doctor:", this.selectedDoctor.name);
},


    validateBillingHeader() {
      this.errorMessage = [];

      if (!this.patientId) {
        this.errorMessage.push("Patient ID is required.");
      }

      if (!this.patientDetails.name || this.patientDetails.name.trim() === "") {
        this.errorMessage.push("Patient name is required.");
      }

      if (!this.patientDetails.age || this.patientDetails.age.trim() === "") {
        this.errorMessage.push("Patient age is required.");
      }

      if (
        !this.patientDetails.gender ||
        this.patientDetails.gender.trim() === ""
      ) {
        this.errorMessage.push("Patient gender is required.");
      }
      if (!this.BillData.billType || this.BillData.billType === "0") {
        this.errorMessage.push("Bill type selection is required.");
      }

      if (!this.BillData.refId || this.BillData.refId.trim() === "") {
        this.errorMessage.push("Bill reference is required.");
      }

      return this.errorMessage.length === 0;
    },
    Save() {
      this.errorMessage = []; // Reset before each validation

      if (!this.validateBillingHeader()) {
        return;
      }
      this.$validator.validate().then((valid) => {
        if (!valid) {
          this.errors.any();
          return;
        } else {
          if (
            this.$refs.billing.checkBillrows() &&
            this.$refs.billing.validateBill()
          ) {
            this.$refs.billing.saveBill().then((result) => {
              if (result) {
                this.saveFlag = true;
                this.readonlyFlag = true;
                this.printFlag = false;
              }
            });
          }
        }
      });
    },
    exit() {
      /*if (this.$route.query.billId) {
            // Came from Billing Dashboard
            this.$router.push({ path: '/billingDashboard' });
        } else if (this.$route.query.patientId) {
            // Came from Patient Tray
            this.$router.push({
            path: '/patientTray',
            query: { patientId: this.$route.query.patientId }
            });
        } else {
            // Fallback, go back
            this.$router.go(-1);
        }*/

      const from = this.$route.query.from;

      if (from === "patientTray") {
        this.$router.push({
          path: "/patientTray",
          query: { patientId: this.$route.query.patientId },
        });
      } else if (from === "billingDashboard") {
        this.$router.push({ path: "/billingDashboard" });
      } else {
        this.$router.go(-1);
      }
    },

     async print() 
     { this.showBill = true;

    this.$nextTick(() => {
      setTimeout(() => {
      window.print();
      this.showBill = false;
      },300)
    }); 
     },

    goTobillDashboard() {
      this.$router.push({ name: "BillingDashboard" });
    },
  },
};
/* getpatientDetails() {
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
            this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.patientDetails = response.data.data;

                });
        },*/
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: -20px;
  width: 100%;
  z-index: 500;
}
.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}
.topPad {
  padding-top: 7px;
}
.bill-input {
  width: 100%;
  box-sizing: border-box;
}

.myselect:focus {
  border: 1px solid blue;
}
.loader-circle {
  border: 5px solid #f3f3f3;
  border-top: 5px solid rgb(25, 71, 170);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 5px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
